module.exports = __webpack_public_path__ + "img/person_add.b377a232.svg";